import * as React from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { cn } from "../../lib/utils"

/**
 * Arrow that points in the "start" direction (left in LTR, right in RTL).
 * Use for collapse/back or "toward start" actions.
 */
const LeftArrowLogical = React.forwardRef<
  SVGSVGElement,
  React.ComponentProps<typeof ChevronLeft>
>(({ className, ...props }, ref) => (
  <ChevronLeft
    ref={ref}
    className={cn("h-4 w-4 rtl:rotate-180", className)}
    {...props}
  />
))
LeftArrowLogical.displayName = "LeftArrowLogical"

/**
 * Arrow that points in the "end" direction (right in LTR, left in RTL).
 * Use for expand/forward or "toward end" actions.
 */
const RightArrowLogical = React.forwardRef<
  SVGSVGElement,
  React.ComponentProps<typeof ChevronRight>
>(({ className, ...props }, ref) => (
  <ChevronRight
    ref={ref}
    className={cn("h-4 w-4 rtl:rotate-180", className)}
    {...props}
  />
))
RightArrowLogical.displayName = "RightArrowLogical"

export { LeftArrowLogical, RightArrowLogical }
